import { useLocalStorage } from '@mantine/hooks';
import { useLayoutContext, usePinnedTracks } from '@livekit/components-react';

export type CallLayout = 'tile' | 'speaker';

export function useCallLayout(): { layout: CallLayout; setLayout: (layout: CallLayout) => void } {
    const layoutContext = useLayoutContext();
    const pinned = usePinnedTracks(layoutContext).length > 0;
    const [preferred, setPreferred] = useLocalStorage<CallLayout>({
        key: 'meet.layout',
        defaultValue: 'tile',
        getInitialValueInEffect: false,
        serialize: (value) => value,
        deserialize: (value) => (value === 'speaker' ? 'speaker' : 'tile'),
    });

    const setLayout = (layout: CallLayout) => {
        if (layout === 'tile') {
            layoutContext.pin.dispatch?.({ msg: 'clear_pin' });
        }
        setPreferred(layout);
    };

    return { layout: pinned ? 'speaker' : preferred, setLayout };
}
